var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { Observable } from 'rxjs';
var PoolCaseComponent = /** @class */ (function () {
    function PoolCaseComponent(router, apiService, util) {
        this.router = router;
        this.apiService = apiService;
        this.util = util;
        this.caseID = "";
        this.caseTicket = "";
        this.sharedHigh = 0;
        this.sharedMedium = 0;
        this.sharedLow = 0;
        this.socialHigh = 0;
        this.socialMedium = 0;
        this.socialLow = 0;
        this.sharedCaseList = [];
        this.socialCaseList = [];
        this.tmpSharedCaseList = [];
        this.tmpSocialCaseList = [];
        this.caseSubTypeSharedList = [];
        this.caseSubTypeSocialList = [];
        this.caseSubTypeDetailSharedList = [];
        this.caseSubTypeDetailSocialList = [];
        this.caseNoShared = "";
        this.firstnameShared = "";
        this.lastnameShared = "";
        this.telephoneShared = "";
        this.caseTypeShared = "";
        this.caseSubTypeShared = "";
        this.subTypeDetailShared = "";
        this.statusShared = "";
        this.caseTypeMy = "";
        this.caseSubTypeMy = "";
        this.subTypeDetailMy = "";
        this.statusMy = "";
        this.caseNoSocial = "";
        this.firstnameSocial = "";
        this.lastnameSocial = "";
        this.telephoneSocial = "";
        this.caseTypeSocial = "";
        this.caseSubTypeSocial = "";
        this.subTypeDetailSocial = "";
        this.statusSocial = "";
        this.dtSharedCase = null;
        this.dtSocialCase = null;
        this.role = {};
        this.isTakeTeamCase = false;
        this.isTakeSocialCase = false;
    }
    PoolCaseComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                thisTs = this;
                this.util.ShowWaiting(true);
                this.util.InitValidation();
                this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                this.role = JSON.parse(this.cookieData.role);
                this.myTeams = JSON.parse(this.cookieData.teams);
                //await this.callApi()
                this.callApi();
                $('#dateFromShared').on('changeDate', function (ev) {
                    $('#dateToShared').datepicker('setStartDate', ev.date);
                });
                $('#dateToShared').on('changeDate', function (ev) {
                    $('#dateFromShared').datepicker('setEndDate', ev.date);
                });
                $('#dateFromSocial').on('changeDate', function (ev) {
                    $('#dateToSocial').datepicker('setStartDate', ev.date);
                });
                $('#dateToSocial').on('changeDate', function (ev) {
                    $('#dateFromSocial').datepicker('setEndDate', ev.date);
                });
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    PoolCaseComponent.prototype.callApi = function () {
        var _this = this;
        var tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
        var sharedPara = "";
        var socialPara = "";
        if (this.role.dpa_list_sharecase) {
            sharedPara = "case_date_from=" + tmpDate + "&casestatuscode=01,02";
            if (this.myTeams != null && this.myTeams.length > 0) {
                this.myTeams.forEach(function (t) {
                    sharedPara += (sharedPara.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid;
                });
            }
        }
        if (this.role.dpa_list_nonvoicepool) {
            socialPara = "case_date_from=" + tmpDate + "&casestatuscode=01";
            socialPara += "&casechannelcode=02,03,04,05";
        }
        Observable.forkJoin(this.apiService.get("master", "caseStatus"), this.apiService.get("master", "caseType"), this.apiService.get("master", "caseSubType"), this.apiService.get("master", "caseSubTypeDetail"), this.apiService.get("crmservice", "caseIncident", sharedPara), this.apiService.get("crmservice", "caseIncident", socialPara)).subscribe(function (data) {
            _this.caseStatusList = data[0];
            _this.caseTypeList = data[1];
            _this.subTypeTmpList = data[2];
            _this.subTypeDetailTmpList = data[3];
            _this.tmpSharedCaseList = data[4];
            _this.tmpSocialCaseList = data[5];
            _this.BindCase();
            _this.util.ShowWaiting(false);
        }, function (err) {
            console.error(err);
            _this.util.ShowWaiting(false);
        });
    };
    PoolCaseComponent.prototype.BindCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var i, order, orderpri, i, order, orderpri;
            return __generator(this, function (_a) {
                this.sharedHigh = this.sharedMedium = this.sharedLow = 0;
                this.socialHigh = this.socialMedium = this.socialLow = 0;
                this.tmpSharedCaseList.forEach(function (c) {
                    if (c.dpa_caseowner == null) {
                        _this.sharedCaseList.push(c);
                        if (c.dpa_caseseverityidname != null) {
                            if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                _this.sharedHigh++;
                            }
                            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                _this.sharedMedium++;
                            }
                            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                _this.sharedLow++;
                            }
                        }
                    }
                });
                for (i = 0; i < this.sharedCaseList.length; i++) {
                    order = 0;
                    orderpri = 0;
                    if (this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                        order = 1;
                    }
                    else if (this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                        order = 2;
                    }
                    else if (this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                        order = 3;
                    }
                    else if (this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                        order = 4;
                    }
                    else if (this.sharedCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                        order = 5;
                    }
                    else {
                        order = 6;
                    }
                    if (this.sharedCaseList[i].dpa_caseseverityidname != null) {
                        if (this.sharedCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                            orderpri = 1;
                        }
                        else if (this.sharedCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                            orderpri = 2;
                        }
                        else if (this.sharedCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                            orderpri = 3;
                        }
                        else {
                            orderpri = 4;
                        }
                    }
                    else {
                        orderpri = 4;
                    }
                    this.sharedCaseList[i].ordercase = order;
                    this.sharedCaseList[i].orderpri = orderpri;
                }
                // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                try {
                    /*
                    tmp.sort(
                      (firstObject: any, secondObject: any) =>
                        (firstObject.orderpri < secondObject.orderpri) ? 1 :
                          (firstObject.orderpri == secondObject.orderpri) ? (
                            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                              (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                                (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                                  (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                                        (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                -1 )
                                :-1
                              -1 )
                              :-1
                          -1 )
                        : -1
                      );
                      */
                    this.sharedCaseList.sort(function (firstObject, secondObject) { return (firstObject.orderpri - secondObject.orderpri
                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                        || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                        || firstObject.ordercase - secondObject.ordercase); });
                }
                catch (_b) {
                }
                this.tmpSocialCaseList.forEach(function (c) {
                    if (c.dpa_caseowner == null) {
                        _this.socialCaseList.push(c);
                        if (c.dpa_caseseverityidname != null) {
                            if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                _this.socialHigh++;
                            }
                            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                _this.socialMedium++;
                            }
                            else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                _this.socialLow++;
                            }
                        }
                    }
                });
                for (i = 0; i < this.socialCaseList.length; i++) {
                    order = 0;
                    orderpri = 0;
                    if (this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                        order = 1;
                    }
                    else if (this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                        order = 2;
                    }
                    else if (this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                        order = 3;
                    }
                    else if (this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                        order = 4;
                    }
                    else if (this.socialCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                        order = 5;
                    }
                    else {
                        order = 6;
                    }
                    if (this.socialCaseList[i].dpa_caseseverityidname != null) {
                        if (this.socialCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                            orderpri = 1;
                        }
                        else if (this.socialCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                            orderpri = 2;
                        }
                        else if (this.socialCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                            orderpri = 3;
                        }
                        else {
                            orderpri = 4;
                        }
                    }
                    else {
                        orderpri = 4;
                    }
                    this.socialCaseList[i].ordercase = order;
                    this.socialCaseList[i].orderpri = orderpri;
                }
                // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                try {
                    /*
                    tmp.sort(
                      (firstObject: any, secondObject: any) =>
                        (firstObject.orderpri < secondObject.orderpri) ? 1 :
                          (firstObject.orderpri == secondObject.orderpri) ? (
                            (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                              (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                                (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                                  (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                                        (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                -1 )
                                :-1
                              -1 )
                              :-1
                          -1 )
                        : -1
                      );
                      */
                    this.sharedCaseList.sort(function (firstObject, secondObject) { return (firstObject.orderpri - secondObject.orderpri
                        || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                        || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                        || firstObject.ordercase - secondObject.ordercase); });
                }
                catch (_c) {
                }
                this.drawTableSharedCase();
                this.drawTableSocialCase();
                return [2 /*return*/];
            });
        });
    };
    PoolCaseComponent.prototype.searchSharedCase = function (getAll) {
        if (getAll === void 0) { getAll = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filterd, tmpDate, sharedPara_1, para_1, fromDtShared, toDtShared, tmpDate, tmp, i, order, orderpri;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.sharedHigh = this.sharedMedium = this.sharedLow = 0;
                        if (!this.role.dpa_list_sharecase) {
                            return [2 /*return*/];
                        }
                        //this.util.ShowWaiting(true)
                        $('#tbSharedCase').DataTable().clear().destroy();
                        filterd = [];
                        if (!getAll) return [3 /*break*/, 2];
                        tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
                        sharedPara_1 = "case_date_from=" + tmpDate + "&casestatuscode=01,02";
                        if (this.myTeams != null && this.myTeams.length > 0) {
                            this.myTeams.forEach(function (t) {
                                sharedPara_1 += (sharedPara_1.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid;
                            });
                        }
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", sharedPara_1)];
                    case 1:
                        filterd = _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        para_1 = "";
                        para_1 = "casestatuscode=01,02";
                        if (this.myTeams != null && this.myTeams.length > 0) {
                            this.myTeams.forEach(function (t) {
                                para_1 += (para_1.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid;
                            });
                        }
                        fromDtShared = $('#dateFromShared').val();
                        toDtShared = $('#dateToShared').val();
                        if (this.caseNoShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "caseno=" + this.caseNoShared;
                        }
                        if (this.firstnameShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "firstname=" + this.firstnameShared;
                        }
                        if (this.lastnameShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "lastname=" + this.lastnameShared;
                        }
                        if (this.telephoneShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "telephone=" + this.telephoneShared;
                        }
                        if (this.caseTypeShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeShared;
                        }
                        if (this.caseSubTypeShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeShared;
                        }
                        if (this.subTypeDetailShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailShared;
                        }
                        if (this.statusShared.trim() != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "casestatusid=" + this.statusShared;
                        }
                        if (fromDtShared != null && fromDtShared != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (toDtShared != null && toDtShared != "") {
                            para_1 += (para_1.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (!(para_1.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", para_1)];
                    case 3:
                        filterd = _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)];
                    case 5:
                        filterd = _a.sent();
                        _a.label = 6;
                    case 6:
                        tmp = [];
                        filterd.forEach(function (c) {
                            if (c.dpa_caseowner == null) {
                                tmp.push(c);
                                if (c.dpa_caseseverityidname != null) {
                                    if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                        _this.sharedHigh++;
                                    }
                                    else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                        _this.sharedMedium++;
                                    }
                                    else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                        _this.sharedLow++;
                                    }
                                }
                            }
                        });
                        for (i = 0; i < tmp.length; i++) {
                            order = 0;
                            orderpri = 0;
                            if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                                order = 1;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                                order = 2;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                                order = 3;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                                order = 4;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                                order = 5;
                            }
                            else {
                                order = 6;
                            }
                            if (tmp[i].dpa_caseseverityidname != null) {
                                if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                    orderpri = 1;
                                }
                                else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                    orderpri = 2;
                                }
                                else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                    orderpri = 3;
                                }
                                else {
                                    orderpri = 4;
                                }
                            }
                            else {
                                orderpri = 4;
                            }
                            tmp[i].ordercase = order;
                            tmp[i].orderpri = orderpri;
                        }
                        // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                        try {
                            /*
                            tmp.sort(
                              (firstObject: any, secondObject: any) =>
                                (firstObject.orderpri < secondObject.orderpri) ? 1 :
                                  (firstObject.orderpri == secondObject.orderpri) ? (
                                    (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                                      (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                                        (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                                          (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                                                (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                        -1 )
                                        :-1
                                      -1 )
                                      :-1
                                  -1 )
                                : -1
                              );
                              */
                            tmp.sort(function (firstObject, secondObject) { return (firstObject.orderpri - secondObject.orderpri
                                || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                || firstObject.ordercase - secondObject.ordercase); });
                        }
                        catch (_b) {
                        }
                        this.sharedCaseList = tmp;
                        this.drawTableSharedCase();
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    PoolCaseComponent.prototype.searchSocialCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para, fromDtSocial, toDtSocial, filterd, tmpDate, tmp, i, order, orderpri;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.socialHigh = this.socialMedium = this.socialLow = 0;
                        if (!this.role.dpa_list_nonvoicepool) {
                            return [2 /*return*/];
                        }
                        //this.util.ShowWaiting(true)
                        $('#tbSocialCase').DataTable().clear().destroy();
                        para = "";
                        para = "casestatuscode=01&casechannelcode=02,03,04,05";
                        fromDtSocial = $('#dateFromSocial').val();
                        toDtSocial = $('#dateToSocial').val();
                        if (this.caseNoSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoSocial;
                        }
                        if (this.firstnameSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameSocial;
                        }
                        if (this.lastnameSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameSocial;
                        }
                        if (this.telephoneSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneSocial;
                        }
                        if (this.caseTypeSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeSocial;
                        }
                        if (this.caseSubTypeSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeSocial;
                        }
                        if (this.subTypeDetailSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailSocial;
                        }
                        if (this.statusSocial.trim() != "") {
                            para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusSocial;
                        }
                        if (fromDtSocial != null && fromDtSocial != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtSocial, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        if (toDtSocial != null && toDtSocial != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtSocial, true), "DD/MM/YYYY").format("YYYY-MM-DD");
                        }
                        filterd = [];
                        if (!(para.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", para)];
                    case 1:
                        filterd = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD");
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)];
                    case 3:
                        filterd = _a.sent();
                        _a.label = 4;
                    case 4:
                        tmp = [];
                        filterd.forEach(function (c) {
                            if (c.dpa_caseowner == null) {
                                tmp.push(c);
                                if (c.dpa_caseseverityidname != null) {
                                    if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                        _this.socialHigh++;
                                    }
                                    else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                        _this.socialMedium++;
                                    }
                                    else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                        _this.socialLow++;
                                    }
                                }
                            }
                        });
                        for (i = 0; i < tmp.length; i++) {
                            order = 0;
                            orderpri = 0;
                            if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress") {
                                order = 1;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold") {
                                order = 2;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new") {
                                order = 3;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved") {
                                order = 4;
                            }
                            else if (tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel") {
                                order = 5;
                            }
                            else {
                                order = 6;
                            }
                            if (tmp[i].dpa_caseseverityidname != null) {
                                if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                    orderpri = 1;
                                }
                                else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                    orderpri = 2;
                                }
                                else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                    orderpri = 3;
                                }
                                else {
                                    orderpri = 4;
                                }
                            }
                            else {
                                orderpri = 4;
                            }
                            tmp[i].ordercase = order;
                            tmp[i].orderpri = orderpri;
                        }
                        // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));
                        try {
                            /*
                            tmp.sort(
                              (firstObject: any, secondObject: any) =>
                                (firstObject.orderpri < secondObject.orderpri) ? 1 :
                                  (firstObject.orderpri == secondObject.orderpri) ? (
                                    (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                                      (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? (
                                        (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                                          (new Date(firstObject.dpa_slatime.substring(0, 10))== new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                                                (firstObject.ordercase  > secondObject.ordercase ) ? 1 :
                                        -1 )
                                        :-1
                                      -1 )
                                      :-1
                                  -1 )
                                : -1
                              );
                              */
                            tmp.sort(function (firstObject, secondObject) { return (firstObject.orderpri - secondObject.orderpri
                                || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
                                || new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
                                || firstObject.ordercase - secondObject.ordercase); });
                        }
                        catch (_b) {
                        }
                        this.socialCaseList = tmp;
                        this.drawTableSocialCase();
                        return [2 /*return*/];
                }
            });
        });
    };
    PoolCaseComponent.prototype.resetSearchSharedCase = function () {
        this.caseNoShared = "";
        this.firstnameShared = "";
        this.lastnameShared = "";
        this.telephoneShared = "";
        this.caseTypeShared = "";
        this.caseSubTypeShared = "";
        this.subTypeDetailShared = "";
        this.statusShared = "";
        this.caseSubTypeSharedList = [];
        this.caseSubTypeDetailSharedList = [];
        $('#dateFromShared').val("").datepicker("update");
        $('#dateToShared').val("").datepicker("update");
    };
    PoolCaseComponent.prototype.resetSearchSocialCase = function () {
        this.caseNoSocial = "";
        this.firstnameSocial = "";
        this.lastnameSocial = "";
        this.telephoneSocial = "";
        this.caseTypeSocial = "";
        this.caseSubTypeSocial = "";
        this.subTypeDetailSocial = "";
        this.statusSocial = "";
        this.caseSubTypeSocialList = [];
        this.caseSubTypeDetailSocialList = [];
        $('#dateFromSocial').val("").datepicker("update");
        $('#dateToSocial').val("").datepicker("update");
    };
    // ngAfterViewInit() {
    //   this.tbShared.changes.subscribe(t => {
    //     this.initTableShared()
    //   })
    //   this.tbSocial.changes.subscribe(t => {
    //     this.initTableSocial()
    //   })
    // }
    // ngForRendred() {
    //   console.log('NgFor is Rendered');
    //   if (this.dtSocialCase == null) {
    //     this.initTableSocial()
    //   }
    //   if (this.dtSharedCase == null) {
    //     this.initTableShared()
    //   }
    // }
    PoolCaseComponent.prototype.initTableShared = function () {
        var thisTs = this;
        $("#tbSharedCase tbody tr").on("click", function () {
            thisTs.caseID = $(this)[0].id;
            thisTs.caseTicket = $(this).find(".col-id")[0].innerText;
            thisTs.isTakeTeamCase = true;
            thisTs.isTakeSocialCase = false;
            $("#takeCaseModal").modal("show");
        });
        this.dtSharedCase = $("#tbSharedCase").dataTable({
            retrieve: true,
            'searching': false,
            order: [],
            "drawCallback": function (settings) {
                console.log('DataTables shared has redrawn the table');
            }
        });
    };
    PoolCaseComponent.prototype.initTableSocial = function () {
        var thisTs = this;
        $("#tbSocialCase tbody tr").on("click", function () {
            thisTs.caseID = $(this)[0].id;
            thisTs.caseTicket = $(this).find(".col-id")[0].innerText;
            thisTs.isTakeTeamCase = false;
            thisTs.isTakeSocialCase = true;
            $("#takeCaseModal").modal("show");
        });
        this.dtSocialCase = $("#tbSocialCase").dataTable({
            retrieve: true,
            'searching': false,
            "drawCallback": function (settings) {
                console.log('DataTables all has redrawn the table');
            }
        });
    };
    PoolCaseComponent.prototype.takeCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        if (this.isTakeTeamCase) {
                            req = this.sharedCaseList.filter(function (c) {
                                return c.incidentid == _this.caseID;
                            });
                        }
                        else {
                            req = this.socialCaseList.filter(function (c) {
                                return c.incidentid == _this.caseID;
                            });
                        }
                        req[0]["dpa_modifiedby"] = this.cookieData.userId;
                        req[0]["dpa_caseowner"] = this.cookieData.userId;
                        return [4 /*yield*/, this.apiService.put("crmservice", "caseIncident-takeOwner/" + this.caseID, req[0])];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 6];
                        $("#takeCaseModal").modal("hide");
                        if (!this.isTakeTeamCase) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.searchSharedCase(true)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.searchSocialCase()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.util.ShowWaiting(false);
                        this.util.SuccessDialog("รับเคสสำเร็จ");
                        setTimeout(function () {
                            var url = _this.util.baseUrl() + "/caseDetail/" + _this.caseTicket;
                            window.open(url, '_blank');
                        }, 800);
                        return [3 /*break*/, 7];
                    case 6:
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog("รับเคสไม่สำเร็จ");
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    PoolCaseComponent.prototype.onCaseTypeSocialChange = function () {
        var _this = this;
        if (this.caseTypeSocial != null && this.caseTypeSocial.length > 0) {
            this.caseSubTypeSocialList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.caseTypeSocial; });
        }
    };
    PoolCaseComponent.prototype.onCaseSubTypeSocialChange = function () {
        var _this = this;
        if (this.caseSubTypeSocial != null && this.caseSubTypeSocial.length > 0) {
            this.caseSubTypeDetailSocialList = this.subTypeDetailTmpList.filter(function (subType) { return subType.dpa_casesubtypeid === _this.caseSubTypeSocial; });
        }
    };
    PoolCaseComponent.prototype.onCaseTypeSharedChange = function () {
        var _this = this;
        if (this.caseTypeShared != null && this.caseTypeShared.length > 0) {
            this.caseSubTypeSharedList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.caseTypeShared; });
        }
    };
    PoolCaseComponent.prototype.onCaseSubTypeSharedChange = function () {
        var _this = this;
        if (this.caseSubTypeShared != null && this.caseSubTypeShared.length > 0) {
            this.caseSubTypeDetailSharedList = this.subTypeDetailTmpList.filter(function (subType) { return subType.dpa_casesubtypeid === _this.caseSubTypeShared; });
        }
    };
    PoolCaseComponent.prototype.drawTableSharedCase = function () {
        var _this = this;
        $("#tbSharedCase tbody").empty();
        this.sharedCaseList.forEach(function (c) {
            var priority = "";
            var tr = "";
            if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center"></td>';
            }
            else {
                var severity = c.dpa_caseseverityidname.toLowerCase();
                if (severity == "high") {
                    priority = "3";
                }
                else if (severity == "medium") {
                    priority = "2";
                }
                else if (severity == "low") {
                    priority = "1";
                }
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center" data-sort="' + priority + '">' +
                    '<span class="dot ' + severity + '"></span>' +
                    '</td>';
            }
            tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
                '<td>' + c.dpa_casesubtypeidname + '</td>' +
                '<td>' + c.customeridname + '</td>' +
                '<td>' + c.dpa_casechannelidname + '</td>' +
                '<td>' + c.dpa_casestatusidname + '</td>' +
                '<td><span class="sr-only">' + _this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' +
                _this.util.transformDate(c.createdon, 'shortWithTime') + '</td>';
            if (c.dpa_issla) {
                tr += '<td align="center" class="high">Over</td>';
            }
            else {
                if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
                    tr += '<td align="center" class="low">Warning</td>';
                }
                else {
                    tr += '<td align="center" class="high"></td>';
                }
            }
            tr += '<td><span class="sr-only">' + _this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>'
                + _this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
                '</tr>';
            $("#tbSharedCase tbody").append(tr);
        });
        this.initTableShared();
    };
    PoolCaseComponent.prototype.drawTableSocialCase = function () {
        var _this = this;
        $("#tbSocialCase tbody").empty();
        this.socialCaseList.forEach(function (c) {
            var priority = "";
            var tr = "";
            if (c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == "") {
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center"></td>';
            }
            else {
                var severity = c.dpa_caseseverityidname.toLowerCase();
                if (severity == "high") {
                    priority = "3";
                }
                else if (severity == "medium") {
                    priority = "2";
                }
                else if (severity == "low") {
                    priority = "1";
                }
                tr += '<tr id="' + c.incidentid + '">' +
                    '<td align="center" data-sort="' + priority + '">' +
                    '<span class="dot ' + severity + '"></span>' +
                    '</td>';
            }
            tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
                '<td>' + c.dpa_casesubtypeidname + '</td>' +
                '<td>' + c.customeridname + '</td>' +
                '<td>' + c.dpa_casechannelidname + '</td>' +
                '<td>' + c.dpa_casestatusidname + '</td>' +
                '<td><span class="sr-only">' + _this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' +
                _this.util.transformDate(c.createdon, 'shortWithTime') + '</td>';
            if (c.dpa_issla) {
                tr += '<td align="center" class="high">Over</td>';
            }
            else {
                if (c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())) {
                    tr += '<td align="center" class="low">Warning</td>';
                }
                else {
                    tr += '<td align="center" class="high"></td>';
                }
            }
            tr += '<td><span class="sr-only">' + _this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>'
                + _this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
                '</tr>';
            $("#tbSocialCase tbody").append(tr);
        });
        this.initTableSocial();
    };
    return PoolCaseComponent;
}());
export { PoolCaseComponent };



// WEBPACK FOOTER //
// ./src/app/pool-case/pool-case.component.ts.pre-build-optimizer.js